import React, { createContext, useContext, useState, useEffect } from 'react';
import { ErrorPage } from './ErrorPage';

const ConfigContext = createContext({ appConfig: null });

export function AppConfigProvider ({ children }) {
  const {
    REACT_APP_APPLICATION_ASSETS_URL,
    REACT_APP_APPLICATION_URL,
    REACT_APP_PUBLIC_CONSOLE_URL,
    REACT_APP_STRIPE_PUBLISHABLE_KEY,
    REACT_APP_STRIPE_PUBLISHABLE_KEY_US,
    REACT_APP_STRIPE_PUBLISHABLE_KEY_NZ,
    REACT_APP_SUPPORT_CONTACT_EMAIL,
    REACT_APP_SUPPORT_CONTACT_PHONE
  } = process.env;

  const appConfig = {
    APPLICATION_ASSETS_URL: REACT_APP_APPLICATION_ASSETS_URL,
    APPLICATION_URL: REACT_APP_APPLICATION_URL,
    PUBLIC_CONSOLE_URL: REACT_APP_PUBLIC_CONSOLE_URL,
    STRIPE_PUBLISHABLE_KEY: REACT_APP_STRIPE_PUBLISHABLE_KEY,
    STRIPE_PUBLISHABLE_KEY_US: REACT_APP_STRIPE_PUBLISHABLE_KEY_US,
    STRIPE_PUBLISHABLE_KEY_NZ: REACT_APP_STRIPE_PUBLISHABLE_KEY_NZ,
    SUPPORT_CONTACT_EMAIL: REACT_APP_SUPPORT_CONTACT_EMAIL,
    SUPPORT_CONTACT_PHONE: REACT_APP_SUPPORT_CONTACT_PHONE
  };

  return <ConfigContext.Provider
    value={{ appConfig }}
    children={children} />
}

export function useAppConfig () {
  return useContext(ConfigContext).appConfig;
}

export function withAppConfig (WrappedComponent) {
	return function WithAppConfig (props) {
    return <ConfigContext.Consumer>
      {({ appConfig }) => {
        return <WrappedComponent {...props} appConfig={appConfig} />
      }}
    </ConfigContext.Consumer>
	}
}
